<template>
  <div>
    <h1 v-text="title" class="primary"></h1>
    <div class="top-actions">
      <!-- Give Kudos Button -->
       <button id="add-kudos-button" :class="`btn ${theme}-bg`" @click="showModal = true" >Give Recognition</button>
       <!-- Rewards Button -->
       <button v-if="rewards.length && content !== 'rewards'" id="rewards-button" :class="`btn ${theme}-bg`" @click="switchContent('rewards')">View Rewards</button>
      <!-- Kudos Button -->
       <button v-if="content !== 'kudos'" id="kudos-button" :class="`btn ${theme}-bg`" @click="switchContent('kudos')">View Recognition</button>
      <!-- Leaderboard Button -->
       <button v-if="content !== 'leaderboard'" id="leaderboard-button" :class="`btn ${theme}-bg`" @click="switchContent('leaderboard')">View Leaderboard</button>
    </div>
    <kudos
      v-if="content === 'kudos'"
      :clientId="clientId"
      :userId="userId"
      :key="key"
      @switchContent="switchContent"
    />
    <modal
      v-if="showModal"
      :clientId="clientId"
      :userId="userId"
      @close="closeModal"
      :theme="theme"
    />
    <leaderboard
      v-if="content === 'leaderboard'"
      :clientId="clientId"
      @switchContent="switchContent"
    />
    <rewards
      v-if="content === 'rewards'"
      :rewards="rewards"
      :userId="userId"
    />
  </div>
</template>

<script>
import Kudos from '../components/Kudos'
import Leaderboard from '../components/Leaderboard'
import Loading from '../components/Loading'
import Modal from '../components/Modal'
import Rewards from '../components/Rewards'

  export default {
    name: 'rewards-and-recognition',
    props: {
      clientId: {
        type: String,
        required: true
      },
      userId: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: false,
        default: 'Rewards & Recognition'
      },
      theme: {
        type: String,
        required: false,
        default: 'primary'
      }
    },
    components: {
      Kudos,
      Leaderboard,
      Loading,
      Modal,
      Rewards
    },
    data: () => ({
      content: 'kudos',
      showModal: false,
      rewards: [],
      key: 0
    }),
    methods: {
      switchContent (content) {
        this.content = content
      },
      async fetchRewards () {
        try {
          const { data } = await axios.get(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/rewards?employeeId=${this.userId}`)
          if (data.success) {
            this.rewards = data.data.map(data => ({
              ...data,
              fireworks: false
            }))
          }
        } catch (error) {
          throw error
        }
      },
      closeModal () {
        this.showModal = false,
        this.key += 1
      }
    },
    mounted () {
      this.fetchRewards()
    }
  }
</script>

<style lang="scss" scoped>

  .top-actions {
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (min-width: 350px) {
      justify-content: flex-end;
    }

    .btn {
      padding: 6px 10px;
      color: white;
      border: none;
      font-family: inherit;
      margin-right: 8px;
    }
  }
</style>